<template>
  <div :key="thisKey" id="background" class="bg">
    <div ref="slider" class="bg-slider">
      <!-- items -->
      <ul class="bg-slider__container">
        <this-item
          v-for="(bgItem, index) in item.items"
          :key="`item${index}`"
          :title="item.title"
          :alias="item.alias"
          :image="bgItem"
        />
      </ul>

      <!-- arrows -->
      <div class="bg-slider__arrows">
        <button
          class="bg-slider__arrow bg-slider__arrow_prev"
          @click="onPrev"
        ></button>
        <button
          class="bg-slider__arrow bg-slider__arrow_next"
          @click="onNext"
        ></button>
      </div>

      <!-- nav -->
      <div class="bg-slider__nav">
        <button
          v-for="(item, index) in item.items"
          :key="index"
          :class="{ 'bg-slider__btn--active': index === activeIndex }"
          class="bg-slider__btn"
          @click="onScrollTo(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EmblaCarousel from "embla-carousel";
import ThisItem from "./item";

export default {
  name: "SliderBackground",

  components: {
    ThisItem
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      thisKey: 0,
      activeIndex: null
    };
  },

  watch: {
    item: {
      immediate: true,
      handler() {
        this.initSlider();
      }
    }
  },

  methods: {
    initSlider() {
      this.embla = null;
      this.thisKey += 1;

      this.$nextTick(() => {
        this.embla = EmblaCarousel(this.$refs.slider, { loop: false });
        this.embla.on("select", this.handleSelect);
      });
    },

    handleSelect() {
      this.activeIndex = this.embla.selectedScrollSnap();
    },

    onPrev() {
      this.embla.scrollPrev();
    },
    onNext() {
      this.embla.scrollNext();
    },

    onScrollTo(index) {
      this.embla.scrollTo(index);
    }
  }
};
</script>

<style>
@import "./index.css";
</style>
